import { z } from 'zod';

import type { CreateSerieVideoLangRequestViewModel } from '@/shared/api/generated';

/**
 * Schema do formulário de Idioma do Vídeo (criar/editar). Validado por Zod
 * (React Hook Form + resolver).
 *
 * NÃO derivado de `createSerieVideoLangRequestViewModelSchema` (gerado pelo
 * Kubb): aquele schema é exportado com o cast `as unknown as ToZod<...>`, o
 * que torna a shape do `ZodObject` uma ficção de tipo — qualquer
 * `.pick()`/`.extend()` sobre ele degrada o `z.infer` para `never` (mesmo
 * problema documentado em `location/types/countryForm.ts`). Por isso o schema
 * é definido aqui diretamente. `cultureInfo` só é obrigatório na criação — na
 * edição o campo Idioma é exibido como texto fixo (não editável).
 */
export const serieVideoLangFormSchema = z.object({
  cultureInfo: z.string().trim().min(1),
  title: z.string().trim().min(1),
  description: z.string(),
  channel: z.string().trim().min(1),
});

/**
 * Valores do formulário de Idioma do Vídeo (create/edit).
 *
 * O tipo intersecta com uma asserção nula (no-op) que só permanece `unknown`
 * enquanto `cultureInfo`/`title`/`embed` continuarem existindo em
 * `CreateSerieVideoLangRequestViewModel` — se um for renomeado/removido no
 * contrato gerado pelo Kubb, a asserção vira `never` e o `yarn type-check`
 * quebra aqui.
 */
export type SerieVideoLangFormValues = z.infer<typeof serieVideoLangFormSchema> &
  ('cultureInfo' | 'title' | 'embed' extends keyof CreateSerieVideoLangRequestViewModel
    ? unknown
    : never);
